module.exports = __webpack_public_path__ + "static/media/epic_cover.4b9e8f37.png";